export const CREATE_MUNICIPALITY_PAYMENT_SCHEDULE =
  "CREATE_MUNICIPALITY_PAYMENT_SCHEDULE";
export const CREATE_MUNICIPALITY_PAYMENT_SCHEDULE_BULK =
  "CREATE_MUNICIPALITY_PAYMENT_SCHEDULE_BULK";
export const FETCH_MUNICIPALITY_PAYMENT_SCHEDULES =
  "FETCH_MUNICIPALITY_PAYMENT_SCHEDULES";
export const FETCH_MUNICIPALITY_PAYMENT_SCHEDULE =
  "FETCH_MUNICIPALITY_PAYMENT_SCHEDULE";
export const EDIT_MUNICIPALITY_PAYMENT_SCHEDULE =
  "EDIT_MUNICIPALITY_PAYMENT_SCHEDULE";
export const DELETE_MUNICIPALITY_PAYMENT_SCHEDULE =
  "DELETE_MUNICIPALITY_PAYMENT_SCHEDULE";
